import {Categorie} from '../dienst/categorie';

export class ClientCategorie {

  static deserialize(dto: ClientCategorieDto): ClientCategorie {
    return new ClientCategorie(
      dto.id,
      dto.taakIds,
    );
  }

  static empty(id: string): ClientCategorie {
    return new ClientCategorie(
      id,
      [],
    );
  }

  static new(categorie: Categorie): ClientCategorie {
    return new ClientCategorie(
      categorie.getId(),
      categorie.getStandaardTaken().map(taak => taak.getId()),
    );
  }

  constructor(
    private id: string,
    private taakIds: Array<string>
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.getId() === id;
  }

  hasTaak(id: string): boolean {
    return this.taakIds.includes(id);
  }

  addAll(ids: Array<string>): void {
    ids.forEach(id => this.add(id));
  }

  add(id: string): void {
    if (!this.hasTaak(id)) {
      this.taakIds.push(id);
    }
  }

  removeAll(ids: Array<string>): void {
    ids.forEach(id => this.remove(id));
  }

  remove(id: string): void {
    const taakIndex = this.taakIds.findIndex(taakId => taakId === id);
    if (taakIndex !== undefined) {
      this.taakIds.splice(taakIndex, 1);
    }
  }
}

export interface ClientCategorieDto {
  id: string;
  taakIds: Array<string>;
}
